module.exports = __webpack_public_path__ + "5c5eaf7d131cda6f1b4e722804c54865.svg";